import { Box2, Shape, Vector2 } from "three";
export function centerShapePoints(shapePoints) {
    const bounds = new Box2().setFromPoints(shapePoints);
    const center = bounds.getCenter(new Vector2());
    // Translate to center, because the PcbLayoutShape.flux is defined to be a bbox-centered F
    // And then scale according to the above calculations.
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    shapePoints.forEach((p) => p.sub(center));
}
export function centerShape(shape) {
    const shapePoints = shape.getPoints();
    centerShapePoints(shapePoints);
    return new Shape(shapePoints);
}
//# sourceMappingURL=centerShape.js.map